<template>
  <div class="settings" v-if="user">
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
          <v-card flat>
            <v-layout child-flex>
              <v-card class="pa-3 app_background" flat>
                <v-card-title>
                  <h1 class="subheading grey--text">Settings</h1>
                  <!-- <v-spacer></v-spacer>
                  <v-btn dark class="pink" @click="$router.push({name: 'Add'})">
                    <v-icon left>mdi-plus</v-icon>Create
                  </v-btn>-->
                </v-card-title>
              </v-card>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-5">
        <p>{{user.email}}</p>
      </v-row>

      <v-row justify="center" class="mt-5">
        <v-btn class="mt-5 grey--text" text @click="logOut">Logout</v-btn>
      </v-row>
    </v-container>

    
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Settings",
  title: "Settings",

  data() {
    return {
      
    };
  },

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  methods: {
    logOut() {
      this.$store.dispatch("logUserOut");
    },
  },
};
</script>

<style></style>
